import { FC } from 'react';
import i18next from 'i18next';
import styled from 'styled-components';

const EmptyTileWrapper = styled.div`
  width: 220px;
  height: 55px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1px;
  margin-top: 1px;
  font-weight: 600;
  font-size: 12px;
  opacity: 0.6;
`;

interface Props {
  t: i18next.TFunction;
}

const EmptyTile: FC<Props> = props => (
  <EmptyTileWrapper data-translation="x.compare.tile.empty.text">
    {props.t('x.compare.tile.empty.text')}
  </EmptyTileWrapper>
);

export default EmptyTile;
